import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId, } from 'react';
import { cx, } from '../utils/ReactUtils.js';
import { getComponentPositionClass, } from './components.js';
export function Textbox({ label = '', error, reserveErrorSpace = 0, className = '', inputClassName = '', position = 'normal', onValueChange, onCommit, alwaysFloat = false, ref, id, type = 'text', disabled = false, value, defaultValue, onBlur, onChange, onFocus, onInput, onKeyDown, placeholder, 'aria-describedby': ariaDescribedBy, 'aria-invalid': ariaInvalid, ...inputProps }) {
    const autoId = useId();
    const inputId = id ?? `textbox-${autoId}`;
    const errorId = `${inputId}-error`;
    function commitInputValue(input) {
        if (typeof onCommit !== 'function') {
            return;
        }
        const currentValue = input.value;
        const nextValue = onCommit(currentValue);
        if (typeof nextValue !== 'string') {
            return;
        }
        if (nextValue === currentValue) {
            return;
        }
        input.value = nextValue;
        if (typeof onValueChange === 'function') {
            onValueChange(nextValue);
        }
    }
    function handleBlur(event) {
        commitInputValue(event.currentTarget);
        if (typeof onBlur === 'function') {
            onBlur(event);
        }
    }
    function handleInput(event) {
        if (typeof onInput === 'function') {
            onInput(event);
        }
    }
    function handleChange(event) {
        if (typeof onChange === 'function') {
            onChange(event);
        }
        if (typeof onValueChange === 'function') {
            onValueChange(event.currentTarget.value);
        }
    }
    function handleKeyDown(event) {
        if (typeof onKeyDown === 'function') {
            onKeyDown(event);
        }
        if (event.defaultPrevented) {
            return;
        }
        if (disabled) {
            return;
        }
        switch (event.key) {
            case 'Enter':
                commitInputValue(event.currentTarget);
                break;
            case 'Escape':
                event.currentTarget.blur();
                break;
        }
    }
    const errorMinHeight = reserveErrorSpace > 0
        ? { minHeight: `${reserveErrorSpace * 1.25}rem` }
        : undefined;
    const positionClass = getComponentPositionClass(position);
    const describedBy = error
        ? [ariaDescribedBy, errorId].filter(Boolean).join(' ')
        : ariaDescribedBy;
    return (_jsxs("div", { className: `w-full ${positionClass} ${className}`, children: [_jsxs("div", { className: cx('textbox-root relative', error ? 'textbox-root-error' : '', alwaysFloat ? 'textbox-root-always-float' : '', disabled ? 'textbox-root-disabled' : ''), children: [_jsx("div", { className: "textbox-control", children: _jsx("input", { ...inputProps, ref: ref, id: inputId, type: type, value: value, defaultValue: defaultValue, disabled: disabled, placeholder: placeholder ?? ' ', "aria-invalid": error ? true : ariaInvalid, "aria-describedby": describedBy, className: cx('textbox-input', inputClassName), onFocus: onFocus, onBlur: handleBlur, onInput: handleInput, onChange: handleChange, onKeyDown: handleKeyDown }) }), _jsx("label", { htmlFor: inputId, className: "textbox-label", children: label })] }), _jsx("p", { id: errorId, className: "input-error", style: errorMinHeight, children: error ?? '' })] }));
}
//# sourceMappingURL=Textbox.js.map